module.exports = __webpack_public_path__ + "static/media/GolosText-Black.a8a1903a.ttf";